import { render, staticRenderFns } from "./EditModelsForm.vue?vue&type=template&id=5ea2188c&"
import script from "./EditModelsForm.vue?vue&type=script&lang=js&"
export * from "./EditModelsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports